import { render, staticRenderFns } from "./ApEventMain.vue?vue&type=template&id=d7896f6e&scoped=true&"
import script from "./ApEventMain.vue?vue&type=script&lang=js&"
export * from "./ApEventMain.vue?vue&type=script&lang=js&"
import style0 from "./ApEventMain.vue?vue&type=style&index=0&id=d7896f6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7896f6e",
  null
  
)

export default component.exports